/** Voice runtimes used by runtime selection, experiments, and telemetry. */
export enum VoiceAgentRuntime {
  Legacy = "legacy",
  SlowThinker = "slow_thinker",
}
